import { useCallback } from 'react';
import {
  createCreateUseModal,
  Flex,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';
import { getScreenWidth } from '../../utils/getScreenWidth/getScreenWidth';
import { DownloadQR } from './DownloadQR';
import { ablyUserAgent } from '@banhala/utils';
import { isWeb } from '../../utils';
import { Keyboard } from 'react-native';
import { useOpenInApp } from './appDeeplink';

const createAlertModal = createCreateUseModal({
  modalProps: {
    coverScreen: isWeb,
    style: {
      margin: 0,
      padding: 0,
      justifyContent: 'center',
      alignItems: 'center',
    },
    deviceWidth: isWeb ? getScreenWidth() : undefined,
    animationIn: 'fadeIn',
    animationOut: 'fadeOut',
    backdropTransitionOutTiming: 10,
    onBackButtonPress() {
      Keyboard?.dismiss();
    },
    onBackdropPress() {
      Keyboard?.dismiss();
    },
  },
  cancelOnBackButtonPress: true,
  cancelOnBackdropPress: true,
});

const useAppDownloadAlertModal = createAlertModal<void, void>(
  ({ confirm }) => {
    const openInApp = useOpenInApp();

    const onPressShowInApp = useCallback(() => {
      if (ablyUserAgent.isMobile) {
        openInApp();
        return;
      }

      confirm();
    }, [confirm, openInApp]);

    return (
      <Flex
        backgroundColor={'white'}
        width={getScreenWidth() - 64}
        borderRadius={12}
        padding={{ top: 24, bottom: 16, horizontal: 16 }}
      >
        <Flex alignItems={'center'} margin={{ bottom: 16 }}>
          <Typography type="h4" color={'content_primary'}>
            해당 기능은 앱에서 사용 가능해요!
          </Typography>
          <Typography type="body1" color={'content_secondary'}>
            앱 설치하고 더 편하게 쇼핑해보세요
          </Typography>
          <Flex
            margin={{ top: 20, bottom: 16 }}
            width={100}
            height={100}
            borderColor={'border_secondary'}
            borderWidth={1}
            borderRadius={12}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <DownloadQR></DownloadQR>
          </Flex>
          <Typography type="body2" color={'content_secondary'}>
            휴대폰으로 QR 코드를 스캔해서 설치해보세요
          </Typography>
        </Flex>

        {ablyUserAgent.isMobile ? (
          <Flex gap={8}>
            <PrimaryButton
              variant={'fill'}
              size={'medium'}
              onPress={onPressShowInApp}
            >
              앱에서 보기
            </PrimaryButton>
            <PrimaryButton
              variant={'fill'}
              size={'medium'}
              onPress={confirm}
              outline
            >
              닫기
            </PrimaryButton>
          </Flex>
        ) : (
          <PrimaryButton variant={'fill'} size={'medium'} onPress={confirm}>
            확인
          </PrimaryButton>
        )}
      </Flex>
    );
  },
);

/**
 * 앱 다운로드 모달 + "앱에서 보기" 동작을 함께 노출한다.
 *
 * 상단 배너처럼 모달을 띄우지 않고 곧바로 앱으로 보내야 하는 곳도 같은 목적지를 써야 해서
 * 딥링크 계산을 이 훅 하나로 모았다(`appDeeplink.ts`).
 */
export const useAppDownloadModal = () => {
  const { show } = useAppDownloadAlertModal();
  const openInApp = useOpenInApp();

  return { show, openInApp };
};
